if (typeof window.initProductMediaGallery !== "function") {
  window.initProductMediaGallery = function initProductMediaGallery(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    const initMainSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-list");
      if (!sliderEl) return;

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      const hasDesktopZoom = sliderEl.dataset?.hasDesktopZoom === "true";
      const buttonPrev = sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext = sliderEl.querySelector(".slider-nav-button--next");
      const paginationEl = sliderEl.querySelector(".slider-pagination");
      const mediaBox = sliderEl.closest(".product__media");
      const thumbsSlider = mediaBox?.querySelector(".js-media-sublist");

      const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 1;

      const initSwiper = () => {
        new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: 16,
          autoHeight: false,
          loop: isLoop,
          direction: "horizontal",
          speed: 800,
          allowTouchMove: true,
          watchSlidesProgress: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            990: {
              allowTouchMove: !hasDesktopZoom,
            },
          },
          thumbs: {
            swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
            //autoScrollOffset: 1,
            multipleActiveThumbs: false,
            slideThumbActiveClass: "swiper-slide-thumb-active",
          },
          on: {
            slideChange: function () {
              window.pauseAllMedia(sliderEl);
              this.params.noSwiping = false;
            },
            slideChangeTransitionEnd: function () {
              const activeIndex = isLoop ? this.realIndex : this.activeIndex;
              const model3D =
                this.slides[activeIndex]?.querySelector("model-viewer");
              const posterBtn3D = this.slides[activeIndex]?.querySelector(
                ".shopify-model-viewer-ui__button--poster"
              );
              if (model3D && posterBtn3D) {
                posterBtn3D.removeAttribute("hidden");
              }
            },
            touchStart: function () {
              const activeIndex = isLoop ? this.realIndex : this.activeIndex;
              const model3D =
                this.slides[activeIndex]?.querySelector("model-viewer");
              if (model3D) {
                if (
                  !model3D.classList.contains(
                    "shopify-model-viewer-ui__disabled"
                  )
                ) {
                  this.params.noSwiping = true;
                  this.params.noSwipingClass = "swiper-slide";
                } else {
                  this.params.noSwiping = false;
                }
              }
            },
          },
        });
      };

      const destroySwiper = () => {
        if (sliderEl.swiper) {
          sliderEl.swiper.destroy();
        }
        sliderEl.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
          wrapper.removeAttribute("style");
        });
        sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
          slide.removeAttribute("style");
        });
      };

      const hasDesktopSwiper =
        desktopType === "slider" || desktopType == "slider_previews";
      const hasMobileSwiper =
        mobileType === "slider" || mobileType == "slider_previews";

      if (hasDesktopSwiper && hasMobileSwiper) {
        initSwiper();
      } else {
        const resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (window.innerWidth >= 990 && hasDesktopSwiper) {
              initSwiper();
              return;
            }

            if (window.innerWidth < 990 && hasMobileSwiper) {
              initSwiper();
              return;
            }

            destroySwiper();
          });
        });

        resizeObserver.observe(section);
      }
    };

    const initSubSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-sublist");
      if (!sliderEl) return;

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      const hasDesktopSwiper = desktopType === "slider_previews";
      const hasMobileSwiper = mobileType === "slider_previews";

      const initSwiper = () => {
        const thumbSlider = new Swiper(sliderEl, {
          spaceBetween: 16,
          slidesPerView: 3,
          loop: false,
          direction: "horizontal",
          allowTouchMove: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoHeight: false,
          slideToClickedSlide: true,
          on: {
            touchEnd: function (swiper) {
              let range = 5;
              let diff = (swiper.touches.diff = swiper.isHorizontal()
                ? swiper.touches.currentX - swiper.touches.startX
                : swiper.touches.currentY - swiper.touches.startY);
              if (diff < range || diff > -range) swiper.allowClick = true;
            },
          },
          breakpoints: {
            576: {
              slidesPerView: 3,
            },
            990: {
              slidesPerView: 3,
              direction: "vertical",
            },
          },
        });

        return thumbSlider;
      };

      if (hasDesktopSwiper || hasMobileSwiper) {
        initSwiper();

        const resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (sliderEl.swiper) {
              if (window.innerWidth >= 990 && hasDesktopSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("vertical", true);
              }

              if (window.innerWidth < 990 && hasMobileSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("horizontal", true);
              }
            }
          });
        });

        resizeObserver.observe(section);
      }
    };

    const initZoomSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sectionBox =
        section.querySelector('[id^="MainProduct-"]') ||
        section.querySelector('[id^="FeaturedProduct-"]');
      const sectionId = sectionBox?.dataset?.section;
      const sliderEl = document.querySelector(
        `[data-section-id='${sectionId}'].js-popup-slider`
      );
      if (!sliderEl) return;

      const buttonPrev = sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext = sliderEl.querySelector(".slider-nav-button--next");
      const paginationEl = sliderEl.querySelector(".slider-pagination");

      const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 1;

      const onMainSliderToggleClick = (event) => {
        if (!sliderEl.swiper) return;
        const zoomToggle = event.target.closest(".product__media-toggle");
        if (!zoomToggle) return;
        const mediaId = zoomToggle.dataset?.mediaId;
        if (!mediaId) return;
        sliderEl
          .querySelectorAll(".product-media-modal__item.swiper-slide")
          .forEach((slide, index) => {
            const zoomImageEl = slide.querySelector(
              `[data-media-id="${mediaId}"]`
            );
            if (zoomImageEl) {
              const findIndex = sliderEl.swiper.slides.findIndex(
                (slideEl) => slideEl.dataset?.mediaId === mediaId
              );
              const fallbackIndex = Number(
                slide.dataset?.swiperSlideIndex || index
              );
              const slideIndex = findIndex !== -1 ? findIndex : fallbackIndex;
              sliderEl.swiper.slideTo(slideIndex, 0);
              sliderEl.swiper.update();
            }
          });
      };

      new Swiper(sliderEl, {
        slidesPerView: 1,
        speed: 800,
        loop: isLoop,
        zoom: {
          maxRatio: 2,
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: buttonNext,
          prevEl: buttonPrev,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        on: {
          afterInit: function () {
            section
              .querySelectorAll(".product__media-list .product__media-toggle")
              .forEach((elem) => {
                elem.addEventListener("click", onMainSliderToggleClick);
              });
          },
          slideChange: function () {
            window.pauseAllMedia(sliderEl);
            this.params.noSwiping = false;
            sliderEl.classList.remove("zoom");
          },
          touchMove: function () {
            sliderEl.classList.remove("zoom");
          },
          slideChangeTransitionEnd: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            const posterBtn3D = this.slides[activeIndex]?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });
    };

    initSubSlider(section);
    initMainSlider(section);
    initZoomSlider(section);

    document.addEventListener("shopify:section:load", (event) => {
      initSubSlider(event.target);
      initMainSlider(event.target);
      initZoomSlider(event.target);
    });
  };
}

if (typeof window.initProductPageElements !== "function") {
  window.initProductPageElements = function initProductPageElements(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    const initProductAccordion = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      section.querySelectorAll(".product-accordion").forEach((details) => {
        const summary = details.querySelector(".product-accordion__toggle");
        const content = details.querySelector(".product-accordion__content");
        let isAnimating = false;

        if (!summary || !content) return;

        summary.addEventListener("click", (event) => {
          if (isAnimating) return;

          event.preventDefault();

          isAnimating = true;

          if (!details.getAttribute("open")) {
            const contentHeight = content.scrollHeight;
            content.style.setProperty(
              "--product-accordion-max-height",
              `${contentHeight}px`
            );

            details.setAttribute("open", true);

            content.addEventListener(
              "transitionend",
              () => {
                isAnimating = false;
              },
              { once: true }
            );
          } else {
            details.removeAttribute("open");

            content.addEventListener(
              "transitionend",
              () => {
                isAnimating = false;
              },
              { once: true }
            );
          }
        });
      });
    };

    const initStickyAddBar = (section) => {
      if (!section || !section.classList.contains("product-section")) {
        return;
      }

      const buyButtons = section.querySelector(
        ".product__buy-buttons > product-form"
      );
      const stickyBar = section.querySelector(".product-sticky-add-bar");
      const footerEl =
        document.querySelector(
          ".shopify-section-group-footer-group .footer__bottom"
        ) ||
        document.querySelector(
          ".shopify-section-group-footer-group .footer__top"
        );

      if (!stickyBar) return;

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.01,
      };

      const isElementBelowScroll = (element) => {
        return element ? element.getBoundingClientRect().top > 0 : false;
      };

      const toggleStickyBar = (isVisible) => {
        if (isVisible || isElementBelowScroll(buyButtons)) {
          stickyBar.classList.remove("active");
        } else {
          stickyBar.classList.add("active");
        }
      };

      const handleIntersect = (entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting);
        toggleStickyBar(isVisible);
      };

      const observer = new IntersectionObserver(
        handleIntersect,
        observerOptions
      );

      if (buyButtons) observer.observe(buyButtons);
      if (footerEl) observer.observe(footerEl);
    };

    initStickyAddBar(section);
    initProductAccordion(section);

    document.addEventListener("shopify:section:load", (event) => {
      initStickyAddBar(event.target);
      if (!window.Shopify.designMode) {
        initProductAccordion(event.target);
      }
    });
  };
}

window.initProductMediaGallery(document.currentScript.parentElement);
window.initProductPageElements(document.currentScript.parentElement);
